import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dummy-chatbot',
  template: '<div id="cx-bot-container"></div>',
  standalone: true,
  imports: [CommonModule]
})
export class ChatbotComponent {}
